import React, { useState, useEffect, useMemo } from "react";
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { Row, Col } from "react-bootstrap";
import "./header.css";
import Geomap from "./geomap/geomap";
import BusinessLocation from "./businessLocation/businessLocation";
import { getConfig } from "../../../../../../../../network/auth";
import { baseUrl } from "../../../../../../../../network/constants/constants";
import axios from "axios";

const Header = ({
  franchise,
  franchiseDetailsData,
  setLoading,
  franchiseId,
  fetchFranchiseDetails,
  editing,
}) => {
  const location = franchiseDetailsData?.location || [];

  const businessLocation = franchiseDetailsData?.business_location || {
    latitude: "",
    longitude: "",
  };

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const [geoMapEditable, setGeoMapEditable] = useState(false);
  const [businessLocationEditable, setBusinessLocationEditable] =
    useState(false);

  const [polygonPoints, setPolygonPoints] = useState("");
  const [businessPoints, setBusinessPoints] = useState("");
  const [fullScreenStates, setFullScreenStates] = useState({
    geoMap: false,
    businessLocation: false,
  });

  const handleGeoMapEdit = () => setGeoMapEditable(!geoMapEditable);
  const handleBusinessLocationEdit = () =>
    setBusinessLocationEditable(!businessLocationEditable);

  const [selectedMap, setSelectedMap] = useState(1);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };

  const handleBusinessLocation = () => {
    setLoading(true);
    const dataToSend = {
      location: polygonPoints,
      business_location: businessPoints,
    };

    axios
      .put(
        baseUrl + `superadmin/business-location/${franchiseId}/`,
        dataToSend,
        config
      )
      .then((response) => {
        setLoading(false);
        localStorage.setItem(
          "localStorageParameters",
          JSON.stringify(response)
        );
        fetchFranchiseDetails();
      })
      .catch((error) => {
        setLoading(false);
        localStorage.setItem(
          "localStorageParametersError",
          JSON.stringify(error)
        );
        // const errorMessage =
        //   error.response?.data?.message ||
        //   "An error occurred. Please try again.";
        // setSnackbar({
        //   open: true,
        //   message: errorMessage,
        //   severity: "error",
        // });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const franchiseDetails = [
    { key: "Franchisee Name", value: franchise.business_title },
    { key: "Place", value: franchise.place },
    { key: "Mobile Number", value: franchise.mobile_number },
    { key: "Franchisee Description", value: franchise.description },
  ];

  const toggleFullScreen = (mapName) => {
    setFullScreenStates((prevState) => ({
      ...prevState,
      [mapName]: !prevState[mapName],
    }));
  };

  useEffect(() => {
    const response = JSON.parse(localStorage.getItem("localStorageParameters")) || null;
   if(response){
    setSnackbar({
      open: true,
      message: response.data.message,
      severity: "success",
    });
   }
   return(() => {
    localStorage.removeItem("localStorageParameters")
   })
  }, []);

  useEffect(() => {
    const error = JSON.parse(localStorage.getItem("localStorageParametersError")) || null;
   if(error){
    setSnackbar({
      open: true,
      message: error.response?.data?.message || "An error occurred. Please try again.",
      severity: "error",
    });
   }
   return(() => {
    localStorage.removeItem("localStorageParametersError")
   })
  }, []);


  return (
    <>
      <h3 className="mb-5 business">{franchise.business_title}</h3>
      <Row>
        <Col lg={6}>
          <Card sx={{ minWidth: 275 }}>
            <CardContent>
              <Typography variant="h6" sx={{ textAlign: "start", mb: 1.5 }}>
                Franchisee Details
              </Typography>
              <Divider sx={{ mb: 2 }} />
              {franchiseDetails.map((detail, index) => (
                <div className="key-value" key={index}>
                  <div className="key">{detail.key} :</div>
                  <div className="value">{detail.value}</div>
                </div>
              ))}
            </CardContent>
          </Card>
        </Col>
      </Row>
      <Row className="mt-5">
        <Col lg={12}>
          <Card sx={{ Width: 275 }} className="p-3 mb-4">
            <Row>
              <Col>
                <Typography variant="h6" sx={{ textAlign: "start", mb: 1.5 }}>
                  Draw Service Location
                </Typography>
              </Col>
              <Col className="d-flex justify-content-end mb-2">
                <Button
                  variant="contained"
                  color={
                    fullScreenStates.geoMap ? "primary" : "secondary"
                  }
                  onClick={() => toggleFullScreen("geoMap")}
                >
                  {fullScreenStates.geoMap
                    ? "Close"
                    : "Expand"}
                </Button>
              </Col>
            </Row>
            <Geomap
              location={location}
              editable={geoMapEditable}
              onEditToggle={handleGeoMapEdit}
              setPolygonPoints={setPolygonPoints}
              selectedMap={selectedMap}
              setSelectedMap={setSelectedMap}
              editing={editing}
              isFullScreen={fullScreenStates.geoMap}
            />
          </Card>
        </Col>
        <Col lg={12}>
          <Card sx={{ Width: 275 }} className="p-3">
            <Row>
              <Col>
                <Typography variant="h6" sx={{ textAlign: "start", mb: 1.5 }}>
                  Edit Franchisee Location
                </Typography>
              </Col>
              <Col className="d-flex justify-content-end mb-2">
                <Button
                  variant="contained"
                  color={
                    fullScreenStates.businessLocation ? "primary" : "secondary"
                  }
                  onClick={() => toggleFullScreen("businessLocation")}
                >
                  {fullScreenStates.businessLocation
                    ? "Close"
                    : "Expand"}
                </Button>
              </Col>
            </Row>
            <BusinessLocation
              businessLocation={businessLocation}
              editable={businessLocationEditable}
              onEditToggle={handleBusinessLocationEdit}
              setBusinessPoints={setBusinessPoints}
              selectedMap={selectedMap}
              setSelectedMap={setSelectedMap}
              editing={editing}
              isFullScreen={fullScreenStates.businessLocation}
            />
          </Card>
        </Col>
      </Row>
      <div className="map-submit-btn-container mt-3">
        <Button
          className="map-submit-btn"
          variant="contained"
          color="success"
          onClick={handleBusinessLocation}
        >
          Confirm the Locations
        </Button>
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Header;
